import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, PLATFORM_ID } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import {
  RelatedPage,
  RelatedPagesComponent,
} from '../../../partials/components/related-pages/related-pages.component';

@Component({
  selector: 'app-solutions-payment-provider',
  imports: [MatIcon, RouterLink, RelatedPagesComponent],
  templateUrl: './payment-provider.component.html',
  styleUrl: './payment-provider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SolutionsPaymentProviderComponent {
  protected readonly relatedPages: RelatedPage[] = [
    {
      link: '/aml-api',
      anchor: "AML API",
      text: "One integration that carries screening into your own payment flow, instead of four provider contracts.",
    },
    {
      link: '/aml-check',
      anchor: "Online AML check",
      text: "The check on its own: a payer address screened against four AML data providers before you settle.",
    },
    {
      link: '/transaction-monitoring',
      anchor: "Crypto transaction monitoring",
      text: "Watch the wallets behind a merchant portfolio and get an alert when their activity changes.",
    },
  ];

  private readonly _platformId = inject(PLATFORM_ID);

  readonly createAccountHref = computed(() => {
    if (!isPlatformBrowser(this._platformId)) {
      return 'https://app.amlofficer.org/register-corporate-account';
    }

    const referralLink = localStorage.getItem('referralLink');
    const trackingLink = localStorage.getItem('trackingLink');
    const queryParams = new URLSearchParams();
    if (referralLink) {
      queryParams.set('referralLink', referralLink);
    }
    if (trackingLink) {
      queryParams.set('trackingLink', trackingLink);
    }
    const query = queryParams.toString();
    return query
      ? `https://app.amlofficer.org/register-corporate-account?${query}`
      : `https://app.amlofficer.org/register-corporate-account`;
  });
}
